import NewApplicationPage from "./Template";

const NewLeaveApplicationPage = () => <NewApplicationPage type="leave" />;

export default NewLeaveApplicationPage;
